const _excluded = ["style", "className", "children", "size", "renderIcon", "aria-label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import BasicButton from './BasicButton';
import { buttonTypePropType } from '../consts';
const id = 'icon-button';
/**
 * Icon Button.
 */
const IconButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      size = 24,
      renderIcon,
      'aria-label': ariaLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const iconProps = {
    size,
    id,
    'aria-hidden': false
  };
  if (ariaLabel) {
    // overwrites the icon's default aria-label
    iconProps['aria-label'] = ariaLabel;
  }
  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    ref: ref,
    className: className,
    "aria-labelledby": id,
    style: [{
      padding: 0,
      width: size,
      height: size,
      color: theme.tokens.colors.icon.secondary.value,
      '&:hover': {
        color: theme.tokens.colors.icon.hover.value
      },
      '&:active': {
        color: theme.tokens.colors.icon.selected.value
      },
      '&:focus': {
        color: theme.tokens.colors.icon.pressed.value
      },
      '&[disabled]': {
        color: theme.tokens.colors.icon.inactive.value,
        cursor: 'not-allowed'
      }
    }, style]
  }, props), children || (renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon(iconProps)));
});
IconButton.displayName = 'IconButton';
IconButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** button html type, eg: submit */
  type: buttonTypePropType,
  /** Icon size, passed only when using `iconType` */
  size: PropTypes.number,
  /** Icon type to display on left */
  renderIcon: PropTypes.func
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map